import React from "react";
import MaterialTable, { MaterialTableProps } from "material-table";

const TranslatedMaterialTable: React.FC<MaterialTableProps<any>> = (props) => {
  return (
    <MaterialTable
      localization={{
        pagination: {
          labelDisplayedRows: "{from}-{to} z {count} ",
          labelRowsPerPage: "pozycji",
          labelRowsSelect: "pozycji",
          firstAriaLabel: "Na początek",
          lastAriaLabel: "Na koniec",
          nextAriaLabel: "Następna strona",
          previousAriaLabel: "Poprzednia strona",
          previousTooltip: "Poprzednia strona",
          nextTooltip: "Następna strona",
          firstTooltip: "Na początek",
          lastTooltip: "Na koniec",
        },
        toolbar: {
          nRowsSelected: "{0} pozycji wybranych",
          searchPlaceholder: "Wyszukaj",
          searchTooltip: "Wyszukaj pozycje",
        },
        header: {
          actions: "",
        },
        body: {
          emptyDataSourceMessage: "Brak pozycji do wyświetlenia",
          filterRow: {
            filterTooltip: "Filter",
          },
        },
      }}
      {...props}
      options={{
        ...props.options,
        pageSize: 10,
        pageSizeOptions: [10, 25, 100],
      }}
    />
  );
};

export default TranslatedMaterialTable;
